/**
 * Navegação da casca logada: qual subestado está na tela (TfrmLoggedStateForm).
 */
import { create } from 'zustand';
import type { ExploreTab } from '../shared.js';
import type { CloudLocation } from '../cloud/cloudModel.js';

export type LoggedSubState =
  | { kind: 'dashboard' }
  /** `query` e `system`: abre já com estas palavras ou com este sistema marcado (a busca e os chips do Início) */
  | { kind: 'rooms'; tab?: ExploreTab; query?: string; system?: string }
  /** o Desk Cloud (docs/spec/desk-cloud.md): `at` abre num lugar e `focus` mostra um arquivo nos detalhes */
  | { kind: 'cloud'; at?: CloudLocation; focus?: string }
  /** `row`: a linha a destacar ao abrir ("Ir para Dados", links de outras telas) */
  | { kind: 'settings'; page?: string; row?: string }
  /** área de administração (só para administradores do servidor; docs/spec/admin.md) */
  | { kind: 'admin'; page?: 'overview' | 'users' | 'plans' | 'rooms' | 'plugins' | 'tutor' | 'server' | 'log' }
  | { kind: 'room'; roomId: string };

type NavStore = {
  sub: LoggedSubState;
  go: (sub: LoggedSubState) => void;
};

export const useLoggedNav = create<NavStore>((set) => ({
  sub: { kind: 'dashboard' },
  go: (sub) => set({ sub }),
}));

